<div class="actions-wrap" fxLayout="column" fxLayoutAlign="center center" *ngIf="!eventsLoaded || events.length">
  
  <!-- <div *ngIf="eventsLoaded && !events.length">
    This connection has no events
  </div> -->

  <div class="search-bar">
    <div fxLayoutAlign="start center">
      <div class="item-title" fxFlex="15" fxLayoutAlign="start center">Events</div>
      <mat-form-field *ngIf="events.length > 10" fxFlex="85" appearance="outline" style="margin-bottom: -1.25em;">
        <mat-label>Search for events</mat-label>
        <input matInput (input)="searchEvents($event)">
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>
    </div>
  </div>

  <spinner *ngIf="spinner" selfSpin="true"></spinner>  
  
  <div 
    *ngIf="events.length"
    class="event-items-wrap"
    fxLayout="row wrap" fxLayoutAlign="start center" 
  >
    <div style="height: 1rem;"></div>
    <!-- <div *ngFor="let object of filteredObjects; trackBy: trackByFn"  fxFlex="15"  class="object-item">
      <button mat-flat-button color="primary">
        <span class="item-name">{{ object.name }}</span>
        <mat-icon>arrow_forward_ios</mat-icon>
      </button>
    </div> -->

    <mat-chip-set>
      <mat-chip 
        class="chip-item" 
        *ngFor="let event of filteredEvents; trackBy: trackByFn" 
      >
        <div fxLayout="row">
          <span class="button-text">{{ event.name }}</span>
          <!-- <mat-icon>chevron_right</mat-icon> -->
        </div>
      </mat-chip>
    </mat-chip-set>
  </div>
</div>